import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'
import { ICONS } from '../../themes'
// Wrapper
// ============================================================
export const AttachedFileStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  min-width: 0;
  max-width: 100%;
  background-color: #f7f7f7;
  border: 1px solid #cccccc;
  display: flex;
  column-gap: 10px;
  align-items: center;
  width: auto;
  border-radius: 6px;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  padding: 10px 14px;
  margin-bottom: 10px;

  /* Child element styles
  ------------------------------- */
  a {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #6c63ff;
    font-weight: 500;

    &:hover {
      color: #003bc8;
    }
  }

  .form-group-control {
    max-width: 100%;
  }

  .form-group-attached-file {
    min-width: 0;
    flex-wrap: wrap;
    display: flex;
    column-gap: 10px;
    row-gap: 5px;
  }

  .attached-file-list {
    margin-top: 10px;
    /* margin-bottom: 10px; */

    .file-name {
      /* margin-right: 10px; */
      margin-left: 20px;
    }
  }

  .tooltip-attachment {
    position: absolute;
    right: 20px;
    width: 18px;
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */
  /* &.has-remove {
    margin-left: 10px;
  } */

  &.is-icon {
    &:before {
      content: '';
      background-image: url(${ICONS['icon-download-file.png']});
      width: 14px;
      height: 17px;
      display: flex;
    }
  }

  &.downloading-icon {
    &:before {
      content: '';
      background-image: url(${ICONS['icon-download.gif']});
      width: 14px;
      height: 17px;
      display: flex;
    }
  }
  /* Media queries
  ------------------------------- */
`
